import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { LockBanner } from '../components/LockBanner';
import Users from '../components/Users';
import ShareDBDoc from '../components/ShareDBDoc';
import ColumnTitle from '../components/ColumnTitle';
import { ReactComponent as ForumDocIcon } from '../icons/icon-forum-doc.svg';
import RichTextField from '../components/BlockComponent/RichTextField';
import { postDocumentScrollHeightMessage } from '../helpers/parent-messaging';
import { ErrorBanner } from '../components/ErrorBanner';

class ForumDoc extends Component {
  render() {
    const {
      currentUser,
      minervaDocId,
      captionsContent,
      darkMode,
      noWhitespace,
      bannerMessage,
    } = this.props;
    const style = noWhitespace
      ? { height: '100%' }
      : { height: '100%', padding: '20px' };

    return (
      <ShareDBDoc
        docId={minervaDocId}
        currentUser={currentUser}
        noPresence={!!currentUser.noPresence}
        readOnly={!!currentUser.readOnly}
      >
        {({ doc, data, presence, readOnlyWorksheet, connectionStatus }) => (
          <>
            {(bannerMessage || readOnlyWorksheet || data.deprecated) && (
              <LockBanner
                text={bannerMessage}
                locked={readOnlyWorksheet}
                deprecated={data.deprecated}
              />
            )}
            <div className="page flex flex-column" style={style}>
              {!currentUser.iframed && (
                <ColumnTitle
                  columnTitle="Forum Doc"
                  columnIcon={<ForumDocIcon />}
                >
                  <Users
                    presence={presence}
                    users={data.users}
                    currentUser={currentUser}
                    doc={doc}
                  />
                </ColumnTitle>
              )}
              <ErrorBanner connectionStatus={connectionStatus} />
              <Editor
                doc={doc}
                data={data.text}
                currentUser={currentUser}
                readOnlyWorksheet={readOnlyWorksheet}
                captionsContent={captionsContent}
                darkMode={darkMode}
              />
            </div>
          </>
        )}
      </ShareDBDoc>
    );
  }
}

const style = { flex: 1, marginBottom: 0 };
const Editor = ({
  doc,
  data,
  currentUser,
  readOnlyWorksheet,
  captionsContent,
  darkMode,
}) => {
  React.useEffect(() => {
    window.parent.postMessage('SLED.performance.renderWorksheet', '*');
    postDocumentScrollHeightMessage();
  }, []);

  return (
    <RichTextField
      doc={doc}
      style={style}
      className="flex flex-column"
      uuid="text"
      data={data}
      currentUser={currentUser}
      height="fullScreen"
      readOnlyWorksheet={readOnlyWorksheet}
      captionsContent={captionsContent}
      darkMode={darkMode}
      focusLast={captionsContent}
    />
  );
};

ForumDoc.defaultTypes = {
  noWhitespace: false,
};

ForumDoc.propTypes = {
  minervaDocId: PropTypes.string,
  currentUser: PropTypes.object.isRequired,
  captionsContent: PropTypes.bool,
  darkMode: PropTypes.bool,
  noWhitespace: PropTypes.bool,
};

export default ForumDoc;
